<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <ng-container class="peak-sale-container">
        <div class="app-container">
            <!-- Header Section -->
            <header class="app-header">
                <div class="container">
                    <h1>Pharmaceutical Forecasting Suite</h1>
                    <!-- <p class="subtitle">Comprehensive Multi-Model Analysis - Evidence-based drug peak sales forecasting using 6 validated methodologies</p> -->
                </div>
            </header>

            <div class="main-content">
                <!-- Left Panel - Drug Information -->
                <div class="left-panel">
                    <div class="card mt-8">
                        <div class="card__header">
                            <h4>Forecast Summary</h4>
                        </div>
                        <div class="card__body">
                            <div class="stats-grid">
                                <div class="stat-item">
                                    <span class="stat-label">Models Completed</span>
                                    <span class="stat-value"
                                        id="modelsCompleted">{{completedCount}}/{{this.modalCompleted.length}}</span>
                                </div>
                                <div class="stat-item">
                                    <span class="stat-label">Peak Revenue Range</span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'analog'">
                                        {{peakRange || '-'}}
                                    </span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'epidemiology'">
                                        {{peakRangeEpidemiology || '-'}}
                                    </span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'market-share'">
                                        {{peakRangeMarketShare || '-'}}
                                    </span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'regression'">
                                        {{peakRangeRegression || '-'}}
                                    </span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'scenario'">
                                        {{peakRangeScenario || '-'}}
                                    </span>
                                    <span class="stat-value" id="peakRange" *ngIf="activeTab === 'monte-carlo'">
                                        {{peakRangeMonteCarlo || '-'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Right Panel - Forecasting Models -->
                <div class="right-panel">
                    <div class="card">
                        <div class="row">
                            <div class="form-group col-6">
                                <label for="drug-name">Enter the Molecule </label>
                                <input type="text" id="drug-name" name="drugName" [(ngModel)]="brandname"
                                    class="form-control" (keydown.enter)="searchMolecule()" autofocus>
                            </div>
                            <div class="form-group col-6" style="display: flex;gap: 10px;">

                                <button type="button" class="btn btn-primary" (click)="searchMolecule()">Search</button>
                                <button type="button" class="btn btn-primary" (click)="refreshData()"
                                    *ngIf="hasSelectedSubMolecule">Reset</button>
                                <button type="button" class="btn btn-primary" (click)="clearData()">Clear</button>

                            </div>
                        </div>

                        <div class="form-group col-6">
                            <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                                [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
                                (onChange)="getData()" *ngIf="subMolecule">
                            </p-dropdown>
                            <!-- <select style="width:90%;" [(ngModel)]="selectedSubMolecule" (change)="getData()">
                                <option [value]="{'code': '', 'name': 'Select NDA'}">Select NDA</option>
                                <option *ngFor="let res of submolecules" [value]="res.code">{{res.name}}</option>
                              </select> -->

                        </div>

                        <div class="card__body" [formGroup]="drugInfoForm">
                            <div class="form-group">
                                <label class="form-label" for="timeframe">Analysis Timeframe (Years)</label>
                                <select id="timeframe" class="form-control" formControlName="timeframe">
                                    <option value="">Select timeframe</option>
                                    <option value="5">5 Years</option>
                                    <option value="10">10 Years</option>
                                    <option value="15">15 Years</option>
                                </select>
                            </div>
                            <!-- <button class="btn btn--primary btn--full-width" (click)="initializeAnalysis()">Initialize Analysis</button> -->
                        </div>

                    </div>

                    <!-- Quick Stats -->

                    <!-- Navigation Tabs -->
                    <div class="tab-navigation">
                        <button class="tab-button" data-tab="analog" [class.active]="activeTab === 'analog'"
                            (click)="setActiveTab('analog')">Analog-Based</button>
                        <button class="tab-button" data-tab="epidemiology" [class.active]="activeTab === 'epidemiology'"
                            (click)="setActiveTab('epidemiology')">Epidemiology-Based</button>
                        <button class="tab-button" data-tab="market-share" [class.active]="activeTab === 'market-share'"
                            (click)="setActiveTab('market-share')">Market Share-Based</button>
                        <button class="tab-button" data-tab="regression"
                            (click)="setActiveTab('regression')">Regression-Based</button>
                        <button class="tab-button" data-tab="scenario" [class.active]="activeTab === 'scenario'"
                            (click)="setActiveTab('scenario')">Scenario-Based</button>
                        <button class="tab-button" data-tab="monte-carlo" [class.active]="activeTab === 'monte-carlo'"
                            (click)="setActiveTab('monte-carlo')">Monte Carlo</button>
                        <button class="tab-button" data-tab="summary" [class.active]="activeTab === 'summary'"
                            (click)="setActiveTab('summary')">Comparative Summary</button>
                    </div>

                    <!-- Tab Content -->
                    <div class="tab-content">
                        <!-- Analog-Based Forecast Tab -->
                        <div class="tab-pane active" id="analog-tab" [class.active]="activeTab === 'analog'">
                            <div class="methodology-section">
                                <h3>Analog-Based Forecast</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Uses historical sales/adoption curves from similar
                                        drugs to project uptake for the target drug</p>
                                    <details class="methodology-details">
                                        <summary>View Step-by-Step Process</summary>
                                        <ol>
                                            <li>Identify analogous drugs with similar characteristics (indication,
                                                mechanism, market dynamics)</li>
                                            <li>Extract historical uptake curves (S-curve parameters: alpha, beta,
                                                gamma)</li>
                                            <li>Adjust for target drug differences (patient pool size, pricing,
                                                competitive landscape)</li>
                                            <li>Apply time-shift adjustments based on market evolution</li>
                                            <li>Scale analog curve to target drug market potential</li>
                                        </ol>
                                    </details>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="analogForm">
                                <h4>Input Parameters</h4>
                                <div class="inputs-grid">
                                    <div class="input-group">
                                        <label class="form-label" for="alpha">Alpha</label>
                                        <input type="number" id="alpha" class="form-control" placeholder="Enter alpha"
                                            formControlName="alpha">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('alpha')?.touched && analogForm.get('alpha')?.hasError('required')">
                                            Alpha is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta">Beta</label>
                                        <input type="number" id="beta" class="form-control" placeholder="Enter beta"
                                            formControlName="beta">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('beta')?.touched && analogForm.get('beta')?.hasError('required')">
                                            Beta is required.</div>
                                    </div>
                                </div>
                                <div class="inputs-grid">

                                    <div class="input-group">
                                        <label class="form-label" for="analogPeakSales">Analog Peak Sales ($M)</label>
                                        <input type="number" id="analogPeakSales" class="form-control"
                                            placeholder="Enter peak sales" formControlName="analogPeakSales">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogPeakSales')?.touched && analogForm.get('analogPeakSales')?.hasError('required')">
                                            Analog peak sales is required.</div>
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogPeakSales')?.touched && analogForm.get('analogPeakSales')?.hasError('min')">
                                            Value must be ≥ 0.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="analogPeakShare">Analog Peak Share (%)</label>
                                        <input type="number" id="analogPeakShare" class="form-control"
                                            placeholder="Enter peak share" min="1" max="100"
                                            formControlName="analogPeakShare">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogPeakShare')?.touched && analogForm.get('analogPeakShare')?.hasError('required')">
                                            Analog peak share is required.</div>
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogPeakShare')?.touched && (analogForm.get('analogPeakShare')?.hasError('min') || analogForm.get('analogPeakShare')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="analogYearsToPeak">Years to Peak</label>
                                        <input type="number" id="analogYearsToPeak" class="form-control"
                                            placeholder="Enter years to peak" min="1"
                                            formControlName="analogYearsToPeak">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogYearsToPeak')?.touched && analogForm.get('analogYearsToPeak')?.hasError('required')">
                                            Years to peak is required.</div>
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('analogYearsToPeak')?.touched && analogForm.get('analogYearsToPeak')?.hasError('min')">
                                            Years to peak must be ≥ 1.</div>

                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="populationRatio">Population Size
                                            Adjustment</label>
                                        <input type="number" id="populationRatio" class="form-control"
                                            placeholder="Enter population ratio" step="0.1"
                                            formControlName="populationRatio">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('populationRatio')?.touched && analogForm.get('populationRatio')?.hasError('required')">
                                            Population ratio is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="pricePremium">Price Premium Factor</label>
                                        <input type="number" id="pricePremium" class="form-control"
                                            placeholder="Enter price premium factor" step="0.05"
                                            formControlName="pricePremium">
                                        <div class="error-msg"
                                            *ngIf="analogForm.get('pricePremium')?.touched && analogForm.get('pricePremium')?.hasError('required')">
                                            Price premium factor is required.</div>
                                    </div>
                                </div>
                                <button class="btn btn--primary mt-8" (click)="calculateAnalogForecast()">Calculate
                                    Forecast</button>
                            </div>

                            <div class="results-section" id="analogResults" *ngIf="showAnalogResults">
                                <h4>Results</h4>
                                <div class="formula-display">
                                    <p><strong>S-Curve Formula:</strong> S(t) = Peak_Sales × (1 / (1 + exp(-(α + βt))))
                                    </p>
                                </div>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="analogChart"></canvas>
                                </div>
                                <div class="key-metrics">
                                    <div class="metric-item">
                                        <span class="metric-label">Projected Peak Sales</span>
                                        <span class="metric-value" id="analogPeakRevenue">-</span>
                                    </div>
                                    <div class="metric-item">
                                        <span class="metric-label">Time to Peak</span>
                                        <span class="metric-value" id="analogTimeToPeak">-</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Epidemiology-Based Tab -->
                        <div class="tab-pane" id="epidemiology-tab" [class.active]="activeTab === 'epidemiology'">
                            <div class="methodology-section">
                                <h3>Epidemiology-Based Forecast</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Bottom-up approach combining disease prevalence,
                                        diagnosis rates, treatment rates, and drug eligibility</p>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="epidemiologyForm">
                                <h4>Input Parameters</h4>
                                <div class="data-sources">
                                    <p><strong>Data Sources:</strong>
                                        <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7446073/"
                                            target="_blank">NCBI Disease Prevalence</a> |
                                        <a href="https://pubmed.ncbi.nlm.nih.gov/" target="_blank">PubMed Treatment
                                            Patterns</a>
                                    </p>
                                </div>
                                <div class="inputs-grid">
                                    <div class="input-group">
                                        <label class="form-label" for="diseasePrevalence">Disease Prevalence (per
                                            100k)</label>
                                        <input type="number" id="diseasePrevalence" class="form-control"
                                            placeholder="Enter disease prevalence" step="0.1"
                                            formControlName="diseasePrevalence">
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="population">Target Population</label>
                                        <input type="number" id="population" class="form-control"
                                            placeholder="Enter population" formControlName="population">
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="diagnosisRate">Diagnosis Rate (%)</label>
                                        <input type="number" id="diagnosisRate" class="form-control"
                                            placeholder="Enter diagnosis rate" min="1" max="100"
                                            formControlName="diagnosisRate">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('diagnosisRate')?.touched && (epidemiologyForm.get('diagnosisRate')?.hasError('min') || epidemiologyForm.get('diagnosisRate')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="treatmentRate">Treatment Rate (%)</label>
                                        <input type="number" id="treatmentRate" class="form-control"
                                            placeholder="Enter treatment rate" min="1" max="100"
                                            formControlName="treatmentRate">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('treatmentRate')?.touched && (epidemiologyForm.get('treatmentRate')?.hasError('min') || epidemiologyForm.get('treatmentRate')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="eligibilityRate">Drug Eligibility (%)</label>
                                        <input type="number" id="eligibilityRate" class="form-control"
                                            placeholder="Enter eligibility rate" min="1" max="100"
                                            formControlName="eligibilityRate">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('eligibilityRate')?.touched && (epidemiologyForm.get('eligibilityRate')?.hasError('min') || epidemiologyForm.get('eligibilityRate')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="epiMarketShare">Peak Market Share (%)</label>
                                        <input type="number" id="epiMarketShare" class="form-control"
                                            placeholder="Enter market share" min="1" max="100"
                                            formControlName="epiMarketShare">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('epiMarketShare')?.touched && (epidemiologyForm.get('epiMarketShare')?.hasError('min') || epidemiologyForm.get('epiMarketShare')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="annualCost">Annual Treatment Cost ($)</label>
                                        <input type="number" id="annualCost" class="form-control"
                                            placeholder="Enter annual treatment cost" formControlName="annualCost">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('annualCost')?.touched && epidemiologyForm.get('annualCost')?.hasError('min')">
                                            Value must be ≥ 0.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="persistenceRate">Persistence Rate</label>
                                        <input type="number" id="persistenceRate" class="form-control"
                                            placeholder="Enter persistence rate" step="0.01" min="0" max="1"
                                            formControlName="persistenceRate">
                                        <div class="error-msg"
                                            *ngIf="epidemiologyForm.get('persistenceRate')?.touched && (epidemiologyForm.get('persistenceRate')?.hasError('min') || epidemiologyForm.get('persistenceRate')?.hasError('max'))">
                                            Enter a value between 0 and 1.</div>
                                    </div>
                                </div>
                                <button class="btn btn--primary mt-8"
                                    (click)="calculateEpidemiologyForecast()">Calculate Forecast</button>
                            </div>

                            <div class="results-section" id="epiResults" *ngIf="showEpiResults">
                                <h4>Patient Funnel & Results</h4>
                                <div class="formula-display">
                                    <p><strong>Formula:</strong> Revenue = Disease_Pop × Diagnosis_Rate × Treatment_Rate
                                        × Eligibility_Rate × Market_Share × Annual_Price × Persistence_Rate</p>
                                </div>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="epiChart"></canvas>
                                </div>
                                <div class="patient-funnel">
                                    <div class="funnel-item">
                                        <span class="funnel-label">Total Disease Population</span>
                                        <span class="funnel-value" id="totalDiseasePopulation">-</span>
                                    </div>
                                    <div class="funnel-item">
                                        <span class="funnel-label">Diagnosed Patients</span>
                                        <span class="funnel-value" id="diagnosedPatients">-</span>
                                    </div>
                                    <div class="funnel-item">
                                        <span class="funnel-label">Treated Patients</span>
                                        <span class="funnel-value" id="treatedPatients">-</span>
                                    </div>
                                    <div class="funnel-item">
                                        <span class="funnel-label">Eligible Patients</span>
                                        <span class="funnel-value" id="eligiblePatients">-</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Market Share-Based Tab -->
                        <div class="tab-pane" id="market-share-tab" [class.active]="activeTab === 'market-share'">
                            <div class="methodology-section">
                                <h3>Market Share-Based Forecast</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Applies market share percentages to total
                                        addressable patient or drug market</p>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="marketShareForm">
                                <h4>Input Parameters</h4>
                                <div class="inputs-grid">
                                    <div class="input-group">
                                        <label class="form-label" for="totalMarket">Total Addressable Market
                                            ($B)</label>
                                        <input type="number" id="totalMarket" class="form-control"
                                            placeholder="Enter total addressable market" step="0.1"
                                            formControlName="totalMarket">
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="marketPeakShare">Peak Market Share (%)</label>
                                        <input type="number" id="marketPeakShare" class="form-control"
                                            placeholder="Enter market share" min="1" max="100"
                                            formControlName="marketPeakShare">
                                        <div class="error-msg"
                                            *ngIf="marketShareForm.get('marketPeakShare')?.touched && (marketShareForm.get('marketPeakShare')?.hasError('min') || marketShareForm.get('marketPeakShare')?.hasError('max'))">
                                            Enter a value between 0 and 100.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="marketYearsToPeak">Years to Peak</label>
                                        <input type="number" id="marketYearsToPeak" class="form-control"
                                            placeholder="Enter years to peak" min="1" max="20"
                                            formControlName="marketYearsToPeak">
                                        <div class="error-msg"
                                            *ngIf="marketShareForm.get('marketYearsToPeak')?.touched && marketShareForm.get('marketYearsToPeak')?.hasError('min')">
                                            Years to peak must be ≥ 1.</div>
                                        <div class="error-msg"
                                            *ngIf="marketShareForm.get('marketYearsToPeak')?.touched && marketShareForm.get('marketYearsToPeak')?.hasError('max')">
                                            Years to peak must be ≤ 20.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="marketGrowth">Market Growth Rate (%/year)</label>
                                        <input type="number" id="marketGrowth" class="form-control"
                                            placeholder="Enter market growth rate" step="0.1"
                                            formControlName="marketGrowth">
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="erosionRate">Post-Peak Erosion (%/year)</label>
                                        <input type="number" id="erosionRate" class="form-control"
                                            placeholder="Enter post-peak erosion" step="0.1"
                                            formControlName="erosionRate">
                                    </div>
                                </div>
                                <button class="btn btn--primary mt-8" (click)="calculateMarketShareForecast()">Calculate
                                    Forecast</button>
                            </div>

                            <div class="results-section" id="marketResults" *ngIf="showMarketResults">
                                <h4>Results</h4>
                                <div class="formula-display">
                                    <p><strong>Formula:</strong> Revenue(t) = Market_Share(t) × Total_Market_Size(t)</p>
                                </div>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="marketChart"></canvas>
                                </div>
                            </div>
                        </div>

                        <!-- Regression-Based Tab -->
                        <div class="tab-pane" id="regression-tab" [class.active]="activeTab === 'regression'">
                            <div class="methodology-section">
                                <h3>Regression-Based Forecast</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Uses regression models trained on historical drug
                                        launch data to extrapolate future performance</p>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="regressionForm">
                                <h4>Input Parameters</h4>
                                <!-- <div class="data-sources">
                                    <p><strong>Training Data:</strong> 
                                        <a href="https://www.globaldata.com/marketplace/pharmaceuticals/" target="_blank">GlobalData Sales</a> | 
                                        <a href="https://pubmed.ncbi.nlm.nih.gov/36382697/" target="_blank">Clinical Outcomes</a>
                                    </p>
                                </div> -->
                                <div class="inputs-grid">

                                    <div class="input-group">
                                        <label class="form-label" for="alpha">Alpha</label>
                                        <input type="number" id="alpha" class="form-control" placeholder="Enter alpha"
                                            formControlName="alpha">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('alpha')?.touched && regressionForm.get('alpha')?.hasError('required')">
                                            Alpha is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta1">Beta1</label>
                                        <input type="number" id="beta1" class="form-control" placeholder="Enter beta1"
                                            formControlName="beta1">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('beta1')?.touched && regressionForm.get('beta1')?.hasError('required')">
                                            Beta1 is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta2">Beta2</label>
                                        <input type="number" id="beta2" class="form-control" placeholder="Enter beta2"
                                            formControlName="beta2">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('beta2')?.touched && regressionForm.get('beta2')?.hasError('required')">
                                            Beta2 is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta3">Beta3</label>
                                        <input type="number" id="beta3" class="form-control" placeholder="Enter beta3"
                                            formControlName="beta3">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('beta3')?.touched && regressionForm.get('beta3')?.hasError('required')">
                                            Beta3 is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta4">Beta4</label>
                                        <input type="number" id="beta4" class="form-control" placeholder="Enter beta4"
                                            formControlName="beta4">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('beta4')?.touched && regressionForm.get('beta4')?.hasError('required')">
                                            Beta4 is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="beta5">Beta5</label>
                                        <input type="number" id="beta5" class="form-control" placeholder="Enter beta5"
                                            formControlName="beta5">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('beta5')?.touched && regressionForm.get('beta5')?.hasError('required')">
                                            Beta5 is required.</div>
                                    </div>




                                    <!-- ------------------------------------------------------------------------- -->
                                    <div class="input-group">
                                        <label class="form-label" for="severityScore">Indication Severity Score
                                            (1-10)</label>
                                        <input type="number" id="severityScore" class="form-control"
                                            placeholder="Enter severity score" min="1" max="10" step="0.1"
                                            formControlName="severityScore">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('severityScore')?.touched && (regressionForm.get('severityScore')?.hasError('min') || regressionForm.get('severityScore')?.hasError('max'))">
                                            Enter a value between 1 and 10.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="regressionCost">Annual Treatment Cost ($)</label>
                                        <input type="number" id="regressionCost" class="form-control"
                                            placeholder="Enter annual treatment cost" formControlName="regressionCost">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('regressionCost')?.touched && regressionForm.get('regressionCost')?.hasError('min')">
                                            Value must be ≥ 0.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="competitiveIndex">Competitive Intensity
                                            (1-5)</label>
                                        <input type="number" id="competitiveIndex" class="form-control"
                                            placeholder="Enter competitive intensity" min="1" max="5" step="0.1"
                                            formControlName="competitiveIndex">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('competitiveIndex')?.touched && (regressionForm.get('competitiveIndex')?.hasError('min') || regressionForm.get('competitiveIndex')?.hasError('max'))">
                                            Enter a value between 1 and 5.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="patientPopSize">Patient Population Size</label>
                                        <input type="number" id="patientPopSize" class="form-control"
                                            placeholder="Enter patient population size"
                                            formControlName="patientPopSize">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('patientPopSize')?.touched && regressionForm.get('patientPopSize')?.hasError('min')">
                                            Value must be ≥ 0.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label" for="regulatoryScore">Regulatory Pathway Score
                                            (1-10)</label>
                                        <input type="number" id="regulatoryScore" class="form-control"
                                            placeholder="Enter regulatory pathway score" min="1" max="10" step="0.1"
                                            formControlName="regulatoryScore">
                                        <div class="error-msg"
                                            *ngIf="regressionForm.get('regulatoryScore')?.touched && (regressionForm.get('regulatoryScore')?.hasError('min') || regressionForm.get('regulatoryScore')?.hasError('max'))">
                                            Enter a value between 1 and 10.</div>
                                    </div>
                                </div>
                                <button class="btn btn--primary mt-8" (click)="calculateRegressionForecast()">Calculate
                                    Forecast</button>
                            </div>

                            <div class="results-section" id="regressionResults" *ngIf="showRegressionResults">
                                <h4>Results</h4>
                                <div class="formula-display">
                                    <p><strong>Formula:</strong> Sales(t) = α + β₁X₁ + β₂X₂ + β₃X₃ + β₄X₄ + β₅X₅ + ε</p>
                                    <p><strong>Coefficients:</strong> α=150M, β₁=250M, β₂=0.03M, β₃=-120M, β₄=0.008M,
                                        β₅=85M</p>
                                </div>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="regressionChart"></canvas>
                                </div>
                            </div>
                        </div>

                        <!-- Scenario-Based Tab -->
                        <div class="tab-pane" id="scenario-tab" [class.active]="activeTab === 'scenario'">
                            <div class="methodology-section">
                                <h3>Scenario-Based Forecast</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Creates multiple forecasts under different
                                        assumptions (base case, optimistic, pessimistic)</p>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="scenarioForm">
                                <h4>Scenario Parameters</h4>
                                <div class="scenario-grid">
                                    <div class="scenario-column">
                                        <h5>Base Case</h5>
                                        <div class="input-group">
                                            <label class="form-label">Uptake Rate (%)</label>
                                            <input type="number" id="baseUptake" class="form-control"
                                                placeholder="Enter uptake rate" formControlName="baseUptake">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Annual Price ($)</label>
                                            <input type="number" id="basePrice" class="form-control"
                                                placeholder="Enter annual price" formControlName="basePrice">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Market Growth (%)</label>
                                            <input type="number" id="baseGrowth" class="form-control"
                                                placeholder="Enter market growth" step="0.1"
                                                formControlName="baseGrowth">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Probability (%)</label>
                                            <input type="number" id="baseProbability" class="form-control"
                                                placeholder="Enter probability" formControlName="baseProbability">
                                        </div>
                                    </div>
                                    <div class="scenario-column">
                                        <h5>Optimistic</h5>
                                        <div class="input-group">
                                            <label class="form-label">Uptake Rate (%)</label>
                                            <input type="number" id="optUptake" class="form-control"
                                                placeholder="Enter uptake rate" formControlName="optUptake">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Annual Price ($)</label>
                                            <input type="number" id="optPrice" class="form-control"
                                                placeholder="Enter annual price" formControlName="optPrice">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Market Growth (%)</label>
                                            <input type="number" id="optGrowth" class="form-control"
                                                placeholder="Enter market growth" step="0.1"
                                                formControlName="optGrowth">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Probability (%)</label>
                                            <input type="number" id="optProbability" class="form-control"
                                                placeholder="Enter probability" formControlName="optProbability">
                                        </div>
                                    </div>
                                    <div class="scenario-column">
                                        <h5>Pessimistic</h5>
                                        <div class="input-group">
                                            <label class="form-label">Uptake Rate (%)</label>
                                            <input type="number" id="pessUptake" class="form-control"
                                                placeholder="Enter uptake rate" formControlName="pessUptake">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Annual Price ($)</label>
                                            <input type="number" id="pessPrice" class="form-control"
                                                placeholder="Enter annual price" formControlName="pessPrice">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Market Growth (%)</label>
                                            <input type="number" id="pessGrowth" class="form-control"
                                                placeholder="Enter market growth" step="0.1"
                                                formControlName="pessGrowth">
                                        </div>
                                        <div class="input-group">
                                            <label class="form-label">Probability (%)</label>
                                            <input type="number" id="pessProbability" class="form-control"
                                                placeholder="Enter probability" formControlName="pessProbability">
                                        </div>
                                    </div>

                                </div>
                                <span class="text-black" style="font-size: 15px;margin-bottom: 10px;font-weight: 600;">
                                    Note : Base Probability + Optimistic Probability + Pessimistic Probability = 100 %
                                    Example : 65 + 25 + 10 = 100

                                </span>
                                <div class="input-group">
                                    <label class="form-label">Patient Count</label>
                                    <input type="number" id="patientCount" class="form-control"
                                        placeholder="Enter patient count" formControlName="patientCount">
                                    <div class="error-msg"
                                        *ngIf="scenarioForm.get('patientCount')?.touched && scenarioForm.get('patientCount')?.hasError('required')">
                                        Patient count is required.</div>
                                </div>
                                <button class="btn btn--primary mt-8" (click)="calculateScenarioForecast()">Calculate
                                    Scenarios</button>
                            </div>

                            <div class="results-section" id="scenarioResults" *ngIf="showScenarioResults">
                                <h4>Scenario Results</h4>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="scenarioChart"></canvas>
                                </div>
                                <div class="scenario-summary">
                                    <div class="scenario-metric">
                                        <span class="scenario-label">Expected Value (Weighted)</span>
                                        <span class="scenario-value" id="expectedValue">-</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Monte Carlo Tab -->
                        <div class="tab-pane" id="monte-carlo-tab" [class.active]="activeTab === 'monte-carlo'">
                            <div class="methodology-section">
                                <h3>Monte Carlo Simulation</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Methodology:</strong> Probabilistic simulation incorporating uncertainty
                                        distributions for key variables</p>
                                </div>
                            </div>

                            <div class="inputs-section" [formGroup]="monteCarloForm">
                                <h4>Distribution Parameters</h4>
                                <div class="inputs-grid">
                                    <div class="input-group">
                                        <label class="form-label">Patient Growth Rate (Normal)</label>
                                        <div class="distribution-inputs">
                                            <input type="number" id="growthMean" class="form-control"
                                                placeholder="Mean %" step="0.1" formControlName="growthMean">
                                            <input type="number" id="growthStd" class="form-control"
                                                placeholder="Std Dev" step="0.1" formControlName="growthStd">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('growthMean')?.touched && monteCarloForm.get('growthMean')?.hasError('required')">
                                                Growth mean is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('growthStd')?.touched && monteCarloForm.get('growthStd')?.hasError('required')">
                                                Growth standard deviation is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('growthStd')?.touched && monteCarloForm.get('growthStd')?.hasError('min')">
                                                Growth standard deviation must be ≥ 0.</div>
                                        </div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label">Annual Price (Uniform)</label>
                                        <div class="distribution-inputs">
                                            <input type="number" id="priceMin" class="form-control" placeholder="Min $"
                                                formControlName="priceMin">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('priceMin')?.touched && monteCarloForm.get('priceMin')?.hasError('required')">
                                                Price min is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('priceMin')?.touched && monteCarloForm.get('priceMin')?.hasError('min')">
                                                Price min must be ≥ 0.</div>
                                            <input type="number" id="priceMax" class="form-control" placeholder="Max $"
                                                formControlName="priceMax">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('priceMax')?.touched && monteCarloForm.get('priceMax')?.hasError('required')">
                                                Price max is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('priceMax')?.touched && monteCarloForm.get('priceMax')?.hasError('required')">
                                                Price max is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('priceMax')?.touched && monteCarloForm.get('priceMax')?.hasError('min')">
                                                Price max must be ≥ 0.</div>
                                        </div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label">Market Penetration (Triangular)</label>
                                        <div class="distribution-inputs">
                                            <input type="number" id="penetrationMin" class="form-control"
                                                placeholder="Min %" formControlName="penetrationMin">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('penetrationMin')?.touched && monteCarloForm.get('penetrationMin')?.hasError('required')">
                                                Market penetration min is required.</div>
                                            <input type="number" id="penetrationMode" class="form-control"
                                                placeholder="Mode %" formControlName="penetrationMode">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('penetrationMode')?.touched && monteCarloForm.get('penetrationMode')?.hasError('required')">
                                                Market penetration mode is required.</div>
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('penetrationMode')?.touched && monteCarloForm.get('penetrationMode')?.hasError('required')">
                                                Market penetration mode is required.</div>
                                            <input type="number" id="penetrationMax" class="form-control"
                                                placeholder="Max %" formControlName="penetrationMax">
                                            <div class="error-msg"
                                                *ngIf="monteCarloForm.get('penetrationMax')?.touched && monteCarloForm.get('penetrationMax')?.hasError('required')">
                                                Market penetration max is required.</div>
                                        </div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label">Number of Simulations</label>
                                        <select id="numSimulations" class="form-control"
                                            formControlName="numSimulations">
                                            <option value="">Select number of simulations</option>
                                            <option value="1000">1,000</option>
                                            <option value="5000">5,000</option>
                                            <option value="10000">10,000</option>
                                            <option value="25000">25,000</option>
                                        </select>
                                        <div class="error-msg"
                                            *ngIf="monteCarloForm.get('numSimulations')?.touched && monteCarloForm.get('numSimulations')?.hasError('required')">
                                            Number of simulations is required.</div>
                                    </div>
                                    <div class="input-group">
                                        <label class="form-label">Base Patient Count</label>
                                        <input type="number" id="basePatientCount" class="form-control"
                                            placeholder="Enter patient count" formControlName="basePatientCount">
                                        <div class="error-msg"
                                            *ngIf="monteCarloForm.get('basePatientCount')?.touched && monteCarloForm.get('basePatientCount')?.hasError('required')">
                                            Patient count is required.</div>
                                    </div>
                                </div>
                                <button class="btn btn--primary mt-8" (click)="runMonteCarloSimulation()">Run
                                    Simulation</button>
                            </div>

                            <div class="results-section" id="monteCarloResults" *ngIf="showMonteCarloResults">
                                <h4>Simulation Results</h4>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="monteCarloChart"></canvas>
                                </div>
                                <div class="monte-carlo-stats">
                                    <div class="stats-row">
                                        <div class="stat-box">
                                            <span class="stat-label">Mean Revenue</span>
                                            <span class="stat-value" id="mcMean">-</span>
                                        </div>
                                        <div class="stat-box">
                                            <span class="stat-label">P10</span>
                                            <span class="stat-value" id="mcP10">-</span>
                                        </div>
                                        <div class="stat-box">
                                            <span class="stat-label">P50 (Median)</span>
                                            <span class="stat-value" id="mcP50">-</span>
                                        </div>
                                        <div class="stat-box">
                                            <span class="stat-label">P90</span>
                                            <span class="stat-value" id="mcP90">-</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Comparative Summary Tab -->
                        <div class="tab-pane" id="summary-tab" [class.active]="activeTab === 'summary'">
                            <div class="methodology-section">
                                <h3>Comparative Summary - All Models</h3>
                                <div class="methodology-explanation">
                                    <p><strong>Analysis:</strong> Side-by-side comparison of all forecasting model
                                        results with consensus analysis</p>
                                </div>
                            </div>

                            <div class="comparison-table">
                                <table class="results-table">
                                    <thead>
                                        <tr>
                                            <th>Model</th>
                                            <th> Revenue</th>
                                            <th>Peak Year</th>
                                            <th>Peak Revenue</th>
                                            <th>Sensitivity Note</th>
                                        </tr>
                                    </thead>
                                    <tbody id="summaryTableBody">
                                        <tr>
                                            <td>Analog-Based</td>
                                            <td id="analogSummaryRevenue">{{analogSummaryRevenue?.['analog based
                                                forecast response']?.revenue || '-'}}</td>
                                            <td id="analogSummaryPeak">{{analogSummaryRevenue?.['analog based forecast
                                                response']?.peakYear || '-'}}</td>
                                            <td id="analogSummaryPeakRev">{{analogSummaryRevenue?.['analog based
                                                forecast response']?.peakRevenue || '-'}}</td>
                                            <td>Sensitive to analog fit</td>
                                        </tr>
                                        <tr>
                                            <td>Epidemiology-Based</td>
                                            <td id="epiSummaryRevenue">{{epidemiologySummaryRevenue?.['epidemiology
                                                based forecast response']?.revenue || '-'}}</td>
                                            <td id="epiSummaryPeak">{{epidemiologySummaryRevenue?.['epidemiology based
                                                forecast response']?.peakYear || '-'}}</td>
                                            <td id="epiSummaryPeakRev">{{epidemiologySummaryRevenue?.['epidemiology
                                                based forecast response']?.peakRevenue || '-'}}</td>

                                            <td>Most robust for clinical scope</td>
                                        </tr>
                                        <tr>
                                            <td>Market Share-Based</td>
                                            <td id="marketSummaryRevenue">{{marketShareSummaryRevenue?.['market share
                                                based forecast response']?.revenue || '-'}}</td>
                                            <td id="marketSummaryPeak">{{marketShareSummaryRevenue?.['market share based
                                                forecast response']?.peakYear || '-'}}</td>
                                            <td id="marketSummaryPeakRev">{{marketShareSummaryRevenue?.['market share
                                                based forecast response']?.peakRevenue || '-'}}</td>

                                            <td>Directly adjustable</td>
                                        </tr>
                                        <tr>
                                            <td>Regression-Based</td>
                                            <td id="regressionSummaryRevenue">{{regressionSummaryRevenue?.['regression
                                                based forecast response']?.revenue || '-'}}</td>
                                            <td id="regressionSummaryPeak">{{regressionSummaryRevenue?.['regression
                                                based forecast response']?.peakYear || '-'}}</td>
                                            <td id="regressionSummaryPeakRev">{{regressionSummaryRevenue?.['regression
                                                based forecast response']?.peakRevenue || '-'}}</td>

                                            <td>Dependent on training data</td>
                                        </tr>
                                        <tr>
                                            <td>Scenario-Based</td>
                                            <td id="scenarioSummaryRevenue">{{scenarioSummaryRevenue?.['scenario based
                                                forecast response']?.revenue || '-'}}</td>
                                            <td id="scenarioSummaryPeak">{{scenarioSummaryRevenue?.['scenario based
                                                forecast response']?.peakYear || '-'}}</td>
                                            <td id="scenarioSummaryPeakRev">{{scenarioSummaryRevenue?.['scenario based
                                                forecast response']?.peakRevenue || '-'}}</td>
                                            <td>Shows effect of uncertainty</td>
                                        </tr>
                                        <tr>
                                            <td>Monte Carlo</td>
                                            <td id="mcSummaryRevenue">{{monteCarloSummaryRevenue?.['monte carlo
                                                simulation response']?.revenue || '-'}}</td>
                                            <td id="mcSummaryPeak">{{monteCarloSummaryRevenue?.['monte carlo simulation
                                                response']?.peakYear || '-'}}</td>
                                            <td id="mcSummaryPeakRev">{{monteCarloSummaryRevenue?.['monte carlo
                                                simulation response']?.peakRevenue || '-'}}</td>
                                            <td>Can highlight risk tail</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="consensus-analysis">
                                <h4>Consensus Analysis</h4>
                                <div class="chart-container" style="position: relative; height: 400px;">
                                    <canvas id="consensusChart"></canvas>
                                </div>
                                <div class="analysis-narrative">
                                    <h5>Key Insights</h5>
                                    <div id="narrativeContent">
                                        <p>Run forecasting models to see consensus analysis and recommendations.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="export-section">
                                <button class="btn btn--primary" onclick="exportResults()">Export Professional Report
                                    (PDF)</button>
                                <button class="btn btn--secondary" onclick="exportToExcel()">Export Data
                                    (Excel)</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>